import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'Helpers/PropTypes';
import { useLottieLoadingContext } from 'Components/ComponentLibrary/Organisms/LottieControl/LottieLoadingLayout';
import { dataAttrs } from 'Helpers/Testing';
import Lottie from 'react-lottie';


export const LottieControl = ({
  src,
  height,
  width,
  loop,
  autoplay,
  onLoadSuccess,
  onLoadError,
  aspectRatio,
  position,
}) => {
  const { fetchLottie } = useLottieLoadingContext();
  const [animationData, setAnimationData] = useState();

  const handleFetchData = useCallback(async (url) => {
    const promise = fetchLottie(url);

    promise.then(setAnimationData);
    promise.catch(() => setAnimationData(undefined));

    promise.then(onLoadSuccess);
    promise.catch(onLoadError);
  }, [fetchLottie]);

  useEffect(() => {
    if (src) {
      handleFetchData(src);
    }
  }, [src, handleFetchData]);


  if (!animationData) return <div style={{ width, height, aspectRatio }} />;

  return (
  // Proceed with caution when adding any additional markup to this file or adjusting any styling within this file
  // since this will affect all of the Lotties rendered in the app.
  // Why not use FDBox here? FDBox applies position relative styling which does not play nicely if we are trying to
  // use absolute positioning on the child component (eg. if the Lottie is being used as a background)
    <div {...dataAttrs('lottie')} data-openreplay-hidden>
      <Lottie
        style={{ position: position ? 'absolute' : undefined }} // These style will be applied to the div that wraps the SVG within the Lottie component
        options={{
          loop,
          autoplay,
          animationData,
          rendererSettings: {
            preserveAspectRatio: 'xMidYMid none',
          },
        }}
        height={height}
        width={width}
        isClickToPauseDisabled
      />
    </div>
  );
};

LottieControl.defaultProps = {
  height: 400,
  width: 400,
  loop: true,
  autoplay: true,
  onLoadSuccess: noop,
  onLoadError: noop,
  aspectRatio: undefined,
  position: undefined,
};

LottieControl.propTypes = {
  src: PropTypes.string.isRequired,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  loop: PropTypes.bool,
  autoplay: PropTypes.bool,
  onLoadSuccess: PropTypes.func,
  onLoadError: PropTypes.func,
  aspectRatio: PropTypes.string,
  position: PropTypes.oneOf(['absolute', 'relative']),
};
